import HomeHeaderSection from "./home-header-section";
import {useSearchParams} from "react-router";
import React, {useEffect, useState} from "react";
import {searchByAddress, searchById, searchByParcelNumber} from "../../services/services";
import RegistersList from "./registers-list/registers-list";
import Landing from "./landing/landing";
import {toaster} from "../../components/ui/toaster";
import {Helmet} from "react-helmet";

function HomePage() {
    const [searchParams] = useSearchParams();
    const [searching, setSearching] = useState(false);
    const [searchResult, setSearchResult] = useState();

    const id = searchParams.get("id");
    const city = searchParams.get("city");
    const street = searchParams.get("street");
    const buildingNr = searchParams.get("buildingNr");
    const apartmentNr = searchParams.get("apartmentNr");
    const parcelNumber = searchParams.get("parcelNumber");

    useEffect(() => {
        if (city && parcelNumber) {
            setSearching(true);
            setSearchResult(undefined);
            searchByParcelNumber(city, parcelNumber)
                .then((result) => {
                    setSearchResult(result.result)
                })
                .catch((error) => {
                    const message = error?.response?.data?.error || 'Wystąpił problem podczas wyszukiwania ksiąg. Skontaktuj się z administratorem systemu'
                    setSearchResult([]);
                    toaster.create({
                        title: message,
                        type: 'error',
                    })
                })
                .finally(() => setSearching(false))
        }

    }, [city, parcelNumber]);

    useEffect(() => {
        if (city && buildingNr) {
            setSearching(true);
            setSearchResult(undefined);
            searchByAddress(city, street, buildingNr, apartmentNr)
                .then((result) => {
                    setSearchResult(result.result)
                })
                .catch((error) => {
                    const message = error?.response?.data?.error || 'Wystąpił problem podczas wyszukiwania ksiąg. Skontaktuj się z administratorem systemu'
                    setSearchResult([]);
                    toaster.create({
                        title: message,
                        type: 'error',
                    })
                })
                .finally(() => setSearching(false))
        }

    }, [city, street, buildingNr, apartmentNr]);

    useEffect(() => {
        if (id) {
            setSearching(true);
            setSearchResult(undefined);
            searchById(id)
                .then((result) => {
                    setSearchResult(result.result)
                })
                .catch((error) => {
                    const message = error?.response?.data?.error || 'Wystąpił problem podczas wyszukiwania ksiąg. Skontaktuj się z administratorem systemu'
                    setSearchResult([]);
                    toaster.create({
                        title: message,
                        type: 'error',
                    })
                })
                .finally(() => setSearching(false))
        }

    }, [id]);

    const showList = searching || searchResult;

    return (
        <>
            <Helmet>
                <title>GeoKsiegi.pl - Wyszukiwarka ksiąg wieczystych | ustal numer księgi</title>
                <meta
                    name="description"
                    content="GeoKsiegi - wyszukiwarka ksiąg wieczystych online. Znajdź numer księgi wieczystej dowolnej nieruchomości w Polsce szybko i łatwo."
                />
                <meta
                    name="keywords"
                    content="kw online, ustal właściciela nieruchomości, baza ksiąg wieczystych, księgi wieczyste, księgi wieczyste online, wyszukiwarka ksiąg wieczystych, elektroniczne księgi wieczyste, ustal numer księgi wieczystej"
                />
            </Helmet>
            <HomeHeaderSection searching={searching} />
            {showList ?
                <RegistersList searching={searching} registersList={searchResult} /> :
                <Landing />
            }
        </>
    );
}

export default HomePage;
